import { render, staticRenderFns } from "./FinancialDashboard.vue?vue&type=template&id=48d09565&scoped=true"
import script from "./FinancialDashboard.vue?vue&type=script&lang=js"
export * from "./FinancialDashboard.vue?vue&type=script&lang=js"
import style0 from "./FinancialDashboard.vue?vue&type=style&index=0&id=48d09565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d09565",
  null
  
)

export default component.exports